module.exports = __webpack_public_path__ + "img/project-6.6e74dcb9.jpg";